module.exports = __webpack_public_path__ + "static/media/sidebar-2.7a0e7660.jpg";